import styled, { css } from 'styled-components';
export const Field = styled.span.withConfig({
  displayName: "Styled__Field",
  componentId: "sc-1j9vbxf-0"
})(["width:100%;> *{width:100%;}"]);
export const Label = styled.label.withConfig({
  displayName: "Styled__Label",
  componentId: "sc-1j9vbxf-1"
})(["position:absolute;left:12px;z-index:1;max-width:calc(100% - 40px);margin:0;overflow-x:hidden;font-size:", "px;color:#b4abab;text-overflow:ellipsis;white-space:nowrap;pointer-events:none;transition:all ease-in-out 0.15s;transform:translateY(20px);"], ({
  theme: {
    fontSize
  }
}) => fontSize.lg);
export const Wrapper = styled.div.withConfig({
  displayName: "Styled__Wrapper",
  componentId: "sc-1j9vbxf-2"
})(["position:relative;display:inline-block;width:100%;min-height:56px;font-size:", "px;cursor:text;transition:all ease-in-out 0.15s;input{padding:26px 30px 10px 12px;font-size:", "px;text-overflow:ellipsis;background-color:white;border:1px solid;border-color:", ";border-radius:initial;outline:none;appearance:none;::-ms-clear{display:none;}::-webkit-input-placeholder{color:transparent;}::-moz-placeholder{color:transparent;}&[disabled]{-webkit-text-fill-color:", " !important;opacity:1;}}", " ", " ", " ", ""], ({
  theme: {
    fontSize
  }
}) => fontSize.lg, ({
  theme: {
    fontSize
  }
}) => fontSize.lg, ({
  theme: {
    color
  }
}) => color.middleGray, ({
  theme: {
    color
  }
}) => color.black, ({
  isDisabled
}) => isDisabled && css(["", "{color:#d8d5d5;}"], Label), ({
  isFocused,
  theme: {
    fontSize
  }
}) => isFocused && css(["input{::-webkit-input-placeholder{color:#dddfe0;}::-moz-placeholder{color:#dddfe0;}}", "{color:#b4abab;font-size:", "px;transform:translateY(10px);}"], Label, fontSize.xs), ({
  isHasValue,
  theme: {
    fontSize
  }
}) => isHasValue && css(["", "{color:#b4abab;font-size:", "px;transform:translateY(10px);}"], Label, fontSize.xs), ({
  isInvalid,
  theme: {
    color
  }
}) => isInvalid && css(["z-index:1;input{border-color:", " red !important;}", "{color:", ";}"], color.error, Label, color.error));
export const Error = styled.label.withConfig({
  displayName: "Styled__Error",
  componentId: "sc-1j9vbxf-3"
})(["display:block;margin:5px 0 0;font-size:", "px;color:", ";text-align:left;"], ({
  theme: {
    fontSize
  }
}) => fontSize.sm, ({
  theme: {
    color
  }
}) => color.error);